import script from "./input.vue?vue&type=script&setup=true&lang=js"
export * from "./input.vue?vue&type=script&setup=true&lang=js"

import "./input.vue?vue&type=style&index=0&id=812cadc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-812cadc8"]])

export default __exports__